module.exports = __webpack_public_path__ + "img/mu.25dc81a7.svg";